module.exports = __webpack_public_path__ + "static/img/example9.4d42114.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/chainmanage/image/example9.jpg
// module id = 715
// module chunks = 1